import { useEffect, useState } from "react";

/**
 * Trailing debounce of a changing value.
 *
 * Debouncing the *value* rather than the handler is what makes it actually work
 * in a function component: a `debounce(handler)` created during render is a new
 * function on every keystroke, so it never gets the chance to swallow one.
 */
export const useDebouncedValue = <Value>(
  value: Value,
  delayMs: number
): Value => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebounced(value), delayMs);

    return () => clearTimeout(timeout);
  }, [value, delayMs]);

  return debounced;
};
